"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../../utils/classNames");
const theme_1 = require("../../../../utils/theme");
const Typography_1 = require("../../../atomic/atoms/Typography");
const InfoFields = ({ fields, classname }) => {
    const theme = (0, theme_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)(classname, 'flex flex-col justify-between md:flex-row'), children: fields?.map(({ label, value }, index) => {
            return value ? ((0, jsx_runtime_1.jsxs)("div", { className: (0, classNames_1.cn)('m-4 flex flex-col', theme.components.infoField.root), children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, { className: (0, classNames_1.cn)('text-base font-bold', theme.components.infoField.fieldLabel), children: label }), (0, jsx_runtime_1.jsx)(Typography_1.Typography, { className: (0, classNames_1.cn)('text-base', theme.components.infoField.fieldValue), children: value })] }, index)) : ((0, jsx_runtime_1.jsx)("div", {}, index));
        }) }));
};
exports.default = InfoFields;
